import { z } from 'zod'

export const uploadFileSchema = z.object({
  /** 檔案 Id */
  fileId: z.string(),
  /** 名稱 */
  name: z.string(),
  /** 副檔名 */
  extension: z.string(),
  /** 檔案大小 */
  size: z.number(),
  /** 路徑 */
  path: z.string()
})

export interface UploadFile extends z.infer<typeof uploadFileSchema> {}
